import { Layout } from '../components/Layout/Layout'
import { ProjectDetails } from '../components/Projects/ProjectDetails'

export const ProjectDetail = () => {

  return (
    <Layout>
      <ProjectDetails/>
    </Layout>
  )
}
